export default {
    isUserLoggedIn: () => {
        const userInfo = localStorage.getItem("userInfo");
        const accessToken = localStorage.getItem("accessToken");
        const expiresIn = localStorage.getItem("expiresIn");

        if (!userInfo || !accessToken || !expiresIn || expiresIn === "undefined") {
            return false;
        }

        return new Date(Date.now()) < new Date(expiresIn);
    },
}